import React, { useState } from "react";
import { CircularProgress } from "@mui/material";
import Popover from "@mui/material/Popover";
import { Button } from "components";
import { Trash } from "components/icons";

import { DotsIcon, EyeIcon } from "../../../../dashboard/icons";


function ImageGalleryItem({ image, onDelete, onPreview }) {
  const { cdn_url, name } = image.file;
  const [loading, setLoading] = useState(true);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleClickPreview = () => {
    onPreview(image);
    handleClose();
  }
  const handleClickDelete = () => {
    onDelete(image);
    handleClose();
  }

  return (
    <div className="visual-menu-image-wrapper position-relative">
      <div className="visual-menu-image position-relative">
        <img
          onLoad={() => setLoading(false)}
          style={{ display: loading ? 'none' : 'block' }}
          src={cdn_url}
          alt={name}
        />

        <CircularProgress
          size={20}
          sx={{ display: loading ? 'block' : 'none', position: "absolute" }}
        />
      </div>
      <div className={`visual-menu-image-menu ${open ? 'open' : ''}`}>
        <div className="more-buttons">
          <Button variant="secondary" size="large" square onClick={handleClick}>
            <DotsIcon />
          </Button>
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handleClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
          >
            <div className={`themes-buttons-dropdown customFadeIn`}>
              <Button variant="secondary" size="large"  onClick={handleClickPreview}>
                <EyeIcon />
                <span>Preview</span>
              </Button>
              <Button variant="secondary" size="large"  className="delete-icon" onClick={handleClickDelete}>
                <Trash />
                <span>Delete</span>
              </Button>
            </div>
          </Popover>
        </div>

      </div>
    </div>
  );
}

export default ImageGalleryItem;
